export interface InnerErrorResponse {
    code?: string;
    innerError?: InnerErrorResponse;
}
